import React from 'react';

function TransparentBackgroundToPreventClick({ popupOpened }) {
  return popupOpened ? <div className='general-close-background z-extra-max' /> : null;
}

export default TransparentBackgroundToPreventClick;
